'use client'

import { cn } from '@vendure/shadcn/util'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { FiExternalLink } from 'react-icons/fi'

const NEXT_PUBLIC_SCHEME_AND_HOST = process.env.NEXT_PUBLIC_SCHEME_AND_HOST

const tabs = [
  { name: 'Description', path: '' },
  { name: 'Changelog', path: 'changelog' },
]

export const DetailTabs = ({
  slug,
  hasChangelog,
  showApiDocsLink,
}: {
  slug: string
  hasChangelog: boolean
  showApiDocsLink: boolean
}) => {
  const pathname = usePathname()

  const activeTabs = hasChangelog
    ? tabs
    : tabs.filter((tab) => tab.path !== 'changelog')

  const isSelected = (path: string) =>
    pathname === `/hub/${slug}/${path}`.replace(/\/$/, '')
  return (
    <div className="border-b border-white/20">
      <div className="-mb-px flex space-x-8">
        {activeTabs.map((tab) => (
          <Link
            href={`/hub/${slug}/${tab.path}`}
            key={tab.name}
            scroll={false}
            className={cn({
              'whitespace-nowrap border-b-2 py-6 font-medium': true,
              'border-primary-600 text-primary-600': isSelected(tab.path),
              'border-transparent text-white/40 hover:border-white/20 hover:text-white/50':
                !isSelected(tab.path),
            })}
          >
            {tab.name}
          </Link>
        ))}
        {showApiDocsLink && (
          <a
            href={NEXT_PUBLIC_SCHEME_AND_HOST + `/hub/${slug}/docs`}
            target="_blank"
            className={cn({
              'whitespace-nowrap border-b-2 py-6 font-medium': true,
              'border-transparent text-white/40 hover:border-white/20 hover:text-white/50':
                true,
            })}
          >
            <span className="flex items-baseline gap-2">
              API Docs <FiExternalLink />
            </span>
          </a>
        )}
      </div>
    </div>
  )
}
